import axios from 'axios'

export const getQuote = ({ data, token, variant, quoteNumber }) => {
  const bodyData = {
    parameters: data,
    authenticity_token: token,
    variant_id: variant,
  }

  if (quoteNumber && quoteNumber !== '') {
    return axios.put(`${Spree.routes.product_quote_url}/${quoteNumber}.json`, bodyData);
  }
  return axios.post(`${Spree.routes.product_quote_url}.json`, bodyData);
}

export const emailQuote = ({ data, token }) => {
  const bodyData = {
    ...data,
    authenticity_token: token,
  };
  // const client = axios.create({});
  return axios.post(`${Spree.routes.product_quote_email_url}.json`, bodyData);
}

export const emailQuoteRequest = (data) => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  let custom_headers = {'content-type': 'multipart/form-data'}
  if(csrf_token) custom_headers['X-CSRF-Token'] = csrf_token
  const client = axios.create({headers: custom_headers});
  const url = `/custom_quote_requests/product`
  return client.post(url, data);
}
